/* ============================================================
   SEE IT IN ACTION — component-see-it-in-action.js
   Loaded with defer — zero render-blocking impact.
   Modal handler uses document-level capture so nothing in the
   theme's group-block overlay can intercept clicks.
   ============================================================ */

/* ── Modal open / close ──────────────────────────────────────── */
(function () {
  'use strict';

  function openModal(container, src, type) {
    var modal  = container.querySelector('[data-siia-modal]');
    var player = container.querySelector('[data-siia-player]');
    if (!modal || !player) return;
    player.innerHTML = type === 'video'
      ? '<video src="' + src + '" class="siia__iframe" autoplay controls playsinline preload="auto"></video>'
      : '<iframe src="' + src + '" class="siia__iframe" allow="autoplay;encrypted-media;picture-in-picture;fullscreen" allowfullscreen></iframe>';
    /* showModal() renders in top layer — above every z-index including sticky headers */
    modal.showModal();
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('[data-siia-close-btn]');
    if (closeBtn) closeBtn.focus();

    /* Click outside content (on ::backdrop) closes the dialog */
    modal.addEventListener('click', function onBdClick(e) {
      if (e.target === modal) { closeModal(modal); modal.removeEventListener('click', onBdClick); }
    });
  }

  function closeModal(modal) {
    if (!modal || !modal.open) return;
    modal.close();
    document.body.style.overflow = '';
    setTimeout(function () {
      var p = modal.querySelector('[data-siia-player]');
      if (p) p.innerHTML = '';
    }, 280);
  }

  /* Capture phase — fires before any theme overlay intercepts */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-siia-trigger]');
    if (trigger) {
      var src  = trigger.dataset.videoSrc;
      var type = trigger.dataset.playerType;
      var cont = trigger.closest('see-it-in-action');
      if (cont && src) { e.stopPropagation(); openModal(cont, src, type); }
      return;
    }
    var closeEl = e.target.closest('[data-siia-close]');
    if (closeEl) {
      var m = closeEl.closest('[data-siia-modal]') || document.querySelector('[data-siia-modal][open]');
      closeModal(m);
    }
  }, true);

  /* <dialog> handles Escape natively, but also stop scroll-lock leak */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.querySelector('[data-siia-modal][open]');
      if (m) { document.body.style.overflow = ''; setTimeout(function(){ var p=m.querySelector('[data-siia-player]'); if(p) p.innerHTML=''; }, 280); }
    }
  });
}());

/* ── Carousel custom element ─────────────────────────────────── */
class SeeItInAction extends HTMLElement {
  connectedCallback() {
    this.track   = this.querySelector('[data-siia-track]');
    this.prevBtn = this.querySelector('[data-siia-prev]');
    this.nextBtn = this.querySelector('[data-siia-next]');
    this.index   = 0;

    /* Carousel prev / next via delegation (no per-item listeners) */
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-siia-prev]')) { this.move(-1); return; }
      if (e.target.closest('[data-siia-next]')) { this.move(1);  return; }
    });

    /* Arrow-key navigation when component is focused */
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.move(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.move(1); }
    });

    this._initCarousel();

    this._onResize = this._debounce(() => { this.index = 0; this._initCarousel(); }, 200);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  _initCarousel() {
    this.items = Array.from(this.querySelectorAll('[data-siia-item]'));
    if (this.track && this.items.length) this._update();
  }

  get _visibleCount() {
    if (!this.items?.[0]) return 1;
    return Math.max(1, Math.floor((this.track.parentElement.offsetWidth + 1) / this.items[0].offsetWidth));
  }

  get _maxIndex() {
    return Math.max(0, (this.items?.length ?? 0) - this._visibleCount);
  }

  move(delta) {
    this.index = Math.min(Math.max(this.index + delta, 0), this._maxIndex);
    this._update();
  }

  _update() {
    if (!this.track || !this.items?.length) return;
    const itemW = this.items[0].offsetWidth;
    const gap   = parseFloat(getComputedStyle(this.track).gap) || 0;
    this.track.style.transform = `translateX(-${this.index * (itemW + gap)}px)`;
    if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index >= this._maxIndex;
  }

  _debounce(fn, ms) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }
}

if (!customElements.get('see-it-in-action')) {
  customElements.define('see-it-in-action', SeeItInAction);
}
